// extracted by mini-css-extract-plugin
export default {"Image":"styles_Image__NQ8P4"};